export default "__VITE_PUBLIC_ASSET__ec4aa0b4__"